<template>
  <div class="payment-popup">
    <div class="head">
      <div class="main-title">
        {{ locales('payment_popup_title') }}
      </div>
    </div>
    <div class="body">
      <payment-plans-widget
        :plans="plans"
        :users-count-list="dropdownUsersSelection"
        :selected="selectedCount"
        :is-annual="isAnnual"
        :is-popup="true"
        @toggleAnnual="toggleAnnual"
        @buyPlanClick="buyPlanClick"
        @upgradePlanClick="upgradePlanClick"
        @changeUserCount="changeUserCount"
      />
      <div
        class="contact-footer"
        v-html="locales('payment_popup_contact_footer')"
      />
    </div>
  </div>
</template>

<script>
import plansModel from '../../../models/plans';
import paymentPlansWidget from '../components/paymentPlansWidget.vue';
import Payment from '../payment';
import app from '../../../app';

export default {
  components: {
    paymentPlansWidget,
  },
  data() {
    return {
      Payment: null,
      locales: __,
      isAnnual: false,
      dropdownUsersSelection: [],
      plans: [],
      selectedCount: null,
    };
  },
  watch: {
    selectedCount(selected) {
      this.plans = this.Payment.getPlansWithCurrentPriceByUserCount(selected.count, this.isAnnual);
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.Payment = new Payment();

      this.isAnnual = plansModel.isTrial() ? true : plansModel.isAnnual();
      this.selectedCount = this.Payment.getNextNumberOfUsersForPaymentPopup();
      if (!this.isAnnual && this.selectedCount.count === 1) {
        this.selectedCount = this.Payment.usersSelection[1];
      }
      this.plans = this.Payment.getPlansWithCurrentPriceByUserCount(this.selectedCount.count, this.isAnnual);
      this.dropdownUsersSelection = this.Payment.disableUnavailableSelection(this.selectedCount.count, this.isAnnual);
    },
    toggleAnnual(isAnnual) {
      this.isAnnual = isAnnual;
      const userCount = this.Payment.getNextNumberOfUsersForPaymentPopup();

      if (!isAnnual && this.selectedCount.count === 1) {
        this.selectedCount = this.Payment.usersSelection[1];
      }

      if (!isAnnual) {
        this.dropdownUsersSelection = this.Payment.disableUnavailableSelection(userCount, true);
      } else {
        this.dropdownUsersSelection = this.Payment.disableUnavailableSelection(userCount, false);
      }

      this.plans = this.Payment.getPlansWithCurrentPriceByUserCount(this.selectedCount.count, this.isAnnual);

      userExtAnalytics.log('pricing_period_changed', { type: this.isAnnual ? 'annually' : 'monthly' });
    },
    changeUserCount(selected) {
      this.selectedCount = selected;
    },
    buyPlanClick(plan) {
      this.Payment.buyPlan(plan, this.selectedCount.count, this.isAnnual);
    },
    upgradePlanClick(plan) {
      this.Payment.upgradePlan(plan, this.selectedCount.count, this.isAnnual);
    },
  },
};
</script>

<style scoped src='../less/paymentPlans.less'></style>
<style lang='less'>
  .contact-footer {
    a {
      padding-left: 4px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
